import { useEffect, useState } from 'react';

export function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBackOnline, setShowBackOnline] = useState(false);

  useEffect(() => {
    let backOnlineTimer: ReturnType<typeof setTimeout> | null = null;
    const online = () => {
      setIsOnline(true);
      setShowBackOnline(true);
      if (backOnlineTimer) {
        clearTimeout(backOnlineTimer);
      }
      backOnlineTimer = setTimeout(() => {
        setShowBackOnline(false);
      }, 2500);
    };
    const offline = () => {
      setIsOnline(false);
      setShowBackOnline(false);
    };

    window.addEventListener('online', online);
    window.addEventListener('offline', offline);

    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
      if (backOnlineTimer) {
        clearTimeout(backOnlineTimer);
      }
    };
  }, []);

  if (isOnline && !showBackOnline) {
    return null;
  }

  const isOffline = !isOnline;
  return (
    <div
      className={`fixed left-4 right-4 z-[60] rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-soft ${
        isOffline ? 'bg-amber-500' : 'bg-emerald-600'
      }`}
      style={{ top: 'calc(env(safe-area-inset-top) + 0.65rem)' }}
    >
      {isOffline
        ? 'You are offline. Connect internet to save changes.'
        : 'Back online. Data actions are available.'}
    </div>
  );
}
